import { useStyles } from './Application.styles'
import { COLOR_PRIMARY } from '../../routes/color-constants'
import { useTranslation } from 'react-i18next'
import { Button, Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { getClientContainer } from 'container/client-modules'
import { CLIENTS_SERVICE_KEY } from 'modules/clients'
import { ClientService } from 'modules/clients/services/ClientService'
import { Query } from 'common/api/Query'
import { getClient2RequestContainer } from 'container/client2request-modules'
import { Client2RequestService } from 'modules/client2Requests/services/Client2RequestService'
import { CLIENT2REQUEST_SERVICE_KEY } from 'modules/client2Requests'
import { useSnackbar } from 'notistack'

type ModalChangeClientProps = {
  requestID: string
  onClose: () => void
  onSaved: () => void
}

const clientService = getClientContainer().get<ClientService>(CLIENTS_SERVICE_KEY)
const client2RequestService = getClient2RequestContainer().get<Client2RequestService>(CLIENT2REQUEST_SERVICE_KEY)

export const ModalChangeClient = (props: ModalChangeClientProps) => {
  const classes = useStyles({ color: COLOR_PRIMARY })
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const [clientOptions, setClientOptions] = useState<{ label: string; value: string }[]>([])
  const [selectedClientID, setSelectedClientID] = useState<string>('')

  useEffect(() => {
    clientService.getFilteredList(new Query({})).subscribe((res) => {
      const options = res.items.map((c) => ({
        label: c.taxName + ' - ' + c.taxIdentity,
        value: c.id || '',
      }))
      setClientOptions(options)
    })
  }, [])

  const handleConfirm = () => {
    if (!selectedClientID) {
      enqueueSnackbar(t('AllFieldsRequired'), { variant: 'error' })
      return
    }

    client2RequestService.changeClient(props.requestID, selectedClientID).subscribe({
      next: () => {
        enqueueSnackbar(t('changeClientSuccess'), { variant: 'success' })
        props.onSaved()
      },
      error: () => {
        enqueueSnackbar(t('changeClientError'), { variant: 'error' })
      },
    })
  }

  return (
    <Grid className={classes.modalConsentPickup2} container>
      <Grid
        xs={12}
        className={classes.title}
        style={{ textAlign: 'center', margin: '20px 0 20px 0' }}>
        {t('changeClient')}
      </Grid>
      <Grid container spacing={4} style={{ padding: '20px 40px' }}>
        <Grid item xs={12}>
          <Select
            options={clientOptions}
            onChange={(option: any) => setSelectedClientID(option?.value || '')}
            placeholder={t('selectClient')}
            styles={{
              control: (baseStyles: any) => ({
                ...baseStyles,
                textAlign: 'left',
                height: '56px',
              }),
              menu: (baseStyles: any) => ({
                ...baseStyles,
                zIndex: 10,
              }),
            }}
          />
        </Grid>
      </Grid>
      <Grid
        xs={12}
        style={{ display: 'flex', justifyContent: 'space-around', margin: '20px 0 20px 0' }}>
        <Button type="button" onClick={props.onClose} className={classes.buttonSecondary}>
          {t('cancel')}
        </Button>
        <Button className={classes.button} type="button" onClick={handleConfirm}>
          {t('save')}
        </Button>
      </Grid>
    </Grid>
  )
}
